import { apiEvents } from "@/common/api";
import sessionService from "@/common/services/session/sessionService";
import { useUserStore } from "@/common/store/userStore";

export type FirehoseProperties = Record<string, string | number | boolean | null | undefined>;

class EventTracker {
  private readonly SOURCE = import.meta.env.REACT_APP_EVENT_SOURCE;

  public async send(eventName: string, properties: FirehoseProperties, pagePath: string) {
    try {
      await apiEvents.track({
        event_name: eventName,
        source: this.SOURCE,
        session_id: (await sessionService.getSession()).session,
        properties,
        page_path: pagePath,
        username: useUserStore.getState().currentUser?.username ?? null,
      });
    } catch (err) {
      console.error("EventsTracker: failed to send event.", err);
    }
  }
}

export default new EventTracker();
